"use client";
import Divider from "@components/common/Divider";
import cx from "classnames";
import styles from "./Contact.module.scss";
import { Badge } from "antd";
import Icon from "@components/common/Icon";
import ButtonCopy from "@components/common/ButtonCopy";
import useCopyText from "@hooks/useCopyText";
const SIZE_ICON = 100;
const View = () => {
  const { copied, handler } = useCopyText();
  return (
    <section data-scroll-section className={cx(styles.section)}>
      <div className="p-8 inner-child">
        <Divider label={<Badge className={cx(styles.badge)}>Liên Hệ</Badge>} />
      </div>
      <div className={cx("inner-child", styles.contact)}>
        <div className="flex flex-col justify-center items-center text-2xl">
          <div className="text-center">
            <br />
            Liên hệ mình qua email
          </div>
          <div
            className={cx(
              "cursor-pointer flex items-center rounded text-white py-4 text-xl px-8 mt-6",
              styles.boxEmail
            )}
            onClick={() => handler.copy("vlaphuong1991@gmail.com")}
          >
            {copied && (
              <Icon
                className={"mr-2"}
                name="clipboard-check-outline"
                color={"white"}
              />
            )}
            {!copied && (
              <Icon className={"mr-2"} name="mail-outline" color={"white"} />
            )}
            <span>vlaphuong1991@gmail.com</span>
          </div>
        </div>
      </div>
    </section>
  );
};
export default View;
